import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { RenderingContext, RenderingContextProvider } from './../../../api';
import { opShareLast } from './../../../utils';
import { WchService } from './../../services/wch.service';
import { AbstractBaseComponent } from './../rendering/abstract-base.component';

/* Copyright IBM Corp. 2017 */
const LOGGER = 'SiteComponent';

@Component({
  selector: 'wch-site',
  templateUrl: './site.component.html',
  styleUrls: ['./site.component.css'],
  preserveWhitespaces: false
})
export class SiteComponent extends AbstractBaseComponent implements OnDestroy, RenderingContextProvider {
  /*
   * Fires whenever the layout mode changed, includes the initial default mode.
   */
  @Output() readonly onLayoutMode: Observable<string>;

  /*
   * The rendering context for the page. This is the context
   * of the element that is referenced by the currently active route.
   */
  @Output() readonly onRenderingContext: Observable<RenderingContext>;

  /*
   * Event that propagates the newly created component
   */
  @Output() readonly onComponent = new EventEmitter<any>();

  constructor(aWchService: WchService) {
    super();

    const that = this;

    this.onRenderingContext = aWchService
      .getRenderingContextForAppConfig()
      .pipe(
        // cache the last value
        opShareLast,
        // end at the right point in time
        takeUntil(that.onOnDestroy)
      );
  }

  // just dispatch, otherwise the method will not be recognized
  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
